const TicketPriority = {
  RUSH: { name: 'Rush', code: 0 },
  SHRT: { name: 'Short', code: 1 },
  NORM: { name: 'Normal', code: 2 },
  REMK: { name: 'Remark', code: 2 },
  DSGN: { name: 'Design', code: 8 },
  EMER: { name: 'Emergency', code: 9, className: 'emergency-card' },
};

export const ticketPriorityHelper = (docType, priority, pge_regCode = null) => {
  let priorityField;
  if (pge_regCode && pge_regCode.toUpperCase() === 'MANUAL') {
    priorityField = { name: 'Manual', className: 'manual-card' };
  } else if (docType === 'fieldMeet') {
    priorityField = { name: 'MeetUp', className: 'field-meet-card' };
  } else if (docType === 'standby') {
    priorityField = { name: 'Standby', className: 'standby-card' };
  } else if (priority && priority.toLowerCase() === 'ticket') {
    priorityField = { name: 'Ticket' };
  } else if (priority && priority.toLowerCase() === 'manual') {
    priorityField = { name: 'Manual', className: 'manual-card' };
  } else if (priority) {
    priorityField = TicketPriority[priority];
  } else if (priority === '') {
    priorityField = { name: 'Normal', code: 2 };
  }
  return priorityField;
};

export const checkAndUpdateSelectedTicketsArray = (selectedArray, id) => {
  let updatedTickets;
  if (selectedArray.includes(id)) {
    const index = selectedArray.indexOf(id);
    updatedTickets = [...selectedArray];
    updatedTickets.splice(index, 1);
  } else {
    updatedTickets = [...selectedArray, id];
  }
  return updatedTickets;
};

export const removeDuplicates = (collection, attribute) => {
  const collectionObj = {};
  Array.isArray(collection) &&
    collection.forEach((item) => {
      if (item && item[attribute]) {
        collectionObj[item[attribute]] = item;
      }
    });

  return Object.values(collectionObj);
};
